import { Injectable } from '@angular/core';
import { filtriDefault, HeatmapCella, Q95ClassCountRow, RischioAnaliticoFiltriValue } from '../models/rischio-analitico.model';
import { BehaviorSubject, Subject } from 'rxjs';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';

/**
 * Stato condiviso dei filtri della sezione "Monitoraggio rischio analitico", tra il sotto-tab
 * Mappa e quello Riepilogo. Component-provided (non providedIn:'root'): una istanza per apertura
 * pannello, azzerata alla chiusura.
 */
@Injectable({ providedIn: 'root' })
export class RischioAnaliticoStateService {
  filtri: RischioAnaliticoFiltriValue = filtriDefault();
  poligono: object | null = null;

  heatmap$: BehaviorSubject<HeatmapCella[]> = new BehaviorSubject<HeatmapCella[]>([]);
  riepilogo$: BehaviorSubject<Q95ClassCountRow[]> = new BehaviorSubject<Q95ClassCountRow[]>([]);

  closeRiepilogo$: Subject<void> = new Subject<void>();
  // heatmap e riepilogo si chiedono solo mentre il pannello Riepilogo e' aperto
  riepilogoAperto$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  caricamentoRiepilogo$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  analyticRiskIsOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  detailFeature$: BehaviorSubject<Feature<Geometry>[]> = new BehaviorSubject<Feature<Geometry>[]>(undefined);
}
